import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusinessTyesService } from '../../services/business-tyes.service';
import { NextTabService } from '../../services/next-tab.service';

@Component({
  selector: 'app-email-verified-successfully',
  templateUrl: './email-verified-successfully.component.html',
  styleUrls: ['./email-verified-successfully.component.scss']
})
export class EmailVerifiedSuccessfullyComponent implements OnInit {

  constructor(
    private _dialogRef: MatDialogRef<EmailVerifiedSuccessfullyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
    private nextTabService:NextTabService
  ) { }

  ngOnInit(): void {
  }
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }


  tabMove(){
    this.nextTabService.updatedDataSelection("next");
    this._dialogRef.close();
  }
}
